module.exports = __webpack_public_path__ + "img/top_bg.11e32fc9.png";